import { Switch } from '@headlessui/react';
import React from 'react';
import { classNames } from '../../utils/class-names';

interface PeriodicitySwitchProps {
  isToggled: boolean;
  onChange: (value: boolean) => void;
}

export default function PeriodicitySwitch(props: PeriodicitySwitchProps) {
  // `isToggled` reflects "billed monthly"; the switch turns on for annual.
  const annually = !props.isToggled;

  return (
    <div className="mx-auto mt-4 mb-4 flex w-[292px] items-center justify-center gap-4">
      <div className="w-[85px] text-right">MONTHLY</div>
      <Switch
        checked={annually}
        onChange={() => props.onChange(!props.isToggled)}
        className={classNames(
          annually ? 'bg-secondary' : 'bg-gray-300',
          'relative inline-flex h-8 w-[58px] shrink-0 cursor-pointer rounded-full transition-colors duration-200 ease-in-out focus:outline-hidden focus:ring-2 focus:ring-secondary focus:ring-offset-2'
        )}
      >
        <span
          aria-hidden="true"
          className={classNames(
            annually ? 'translate-x-[26px]' : 'translate-x-0',
            'pointer-events-none absolute top-[3px] left-[3px] inline-block h-[26px] w-[26px] rounded-full bg-white shadow-sm transition duration-200 ease-in-out'
          )}
        />
      </Switch>
      <div className="w-[85px] text-left">
        ANNUALLY
        <div className="text-[12px] text-green-600">save 2 months</div>
      </div>
    </div>
  );
}
